import dayjs from 'dayjs'
import * as moment from 'moment'

export const standardDate = (date) => {
  if (date && typeof date === 'object') {
    return date.toDate()
  }
  return date
}

export const getTimeZoneDifferentNumber = (timeZoneClientOrStore) => {
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || moment.tz.guess()
  const storeOffset = moment().tz(timeZoneClientOrStore).utcOffset()
  const browserOffset = moment()
    .tz(browserTimezone || timeZoneClientOrStore)
    .utcOffset()
  let timeZoneDifferenceNumber = storeOffset !== browserOffset ? storeOffset / 60 : null

  return timeZoneDifferenceNumber > 0 ? `+${timeZoneDifferenceNumber}` : timeZoneDifferenceNumber
}

export const getCustomDate = (day, month, hour) => {
  return dayjs().set('date', day).set('month', month).set('hour', hour)
}

export const getQuotaHourRanges = (timezone, day, hour, month) => {
  const dateToFormatFrom = moment()
    .tz(timezone)
    .set({ month: month, date: day, hour: hour, minute: 0, second: 0, millisecond: 0 })

  const dateToFormatTo = moment()
    .tz(timezone)
    .set({ month: month, date: day, hour: hour, minute: 0, second: 0, millisecond: 0 })
    .add(1, 'hour')

  const from = dateToFormatFrom.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
  const to = dateToFormatTo.utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
  return [from, to]
}

export const hoursFormatted = (hour) => {
  const hours = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00'
  ]

  return hours[hour]
}

export const getTimeZoneNumber = (timeZoneClientOrStore) => {
  const storeOffset = moment().tz(timeZoneClientOrStore).utcOffset()
  let timeZoneDifferenceNumber = storeOffset ? storeOffset / 60 : null

  return timeZoneDifferenceNumber > 0 ? `+${timeZoneDifferenceNumber}` : timeZoneDifferenceNumber
}

export const dateFormat = 'YYYY-MM-DD'

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss'

export const dateSlotFormat = 'YYYY-MM-DD HH:mm'

export const formatHourWithUtc = (date) => {
  return dayjs.utc(date).format(dateTimeFormat)
}

export const getDateDifferences = (startDate, endDate) => {
  const getDateAsArray = (date) => {
    return dayjs(date.split(/\D+/), dateFormat)
  }
  const differenceDates = getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1
  const dates = []
  for (let i = 0; i < differenceDates; i++) {
    const nextDate = getDateAsArray(startDate).add(i, 'day')
    dates.push(nextDate.format(dateFormat))
  }
  return dates
}

export const calculateQuantityTime = (time) => {
  let differenceOfTime
  let typeOfTime

  switch (true) {
    case time < 60:
      differenceOfTime = time
      typeOfTime = 'time.minute'
      break
    case time >= 60 && time < 1440:
      differenceOfTime = Math.floor(time / 60)
      typeOfTime = 'time.hour'
      break
    case time >= 1440:
      differenceOfTime = Math.floor(time / 1440)
      typeOfTime = 'time.day'
      break
    default:
      break
  }

  return {
    differenceOfTime: differenceOfTime,
    typeOfTime: typeOfTime
  }
}

export const calculateDifferenceOfDaysOrHours = (slotTo) => {
  const customToday = dayjs.utc().format(dateTimeFormat)
  const customDeliveryDate = dayjs.utc(slotTo).format(dateTimeFormat)
  const today = dayjs(customToday)
  const deliveryDateClient = dayjs(customDeliveryDate)

  let differenceOfTime
  let haveDelayInDelivery
  let typeOfTime

  if (today > deliveryDateClient) {
    const quantityTime = calculateQuantityTime(today.diff(deliveryDateClient, 'minutes'))
    haveDelayInDelivery = true
    differenceOfTime = quantityTime.differenceOfTime
    typeOfTime = quantityTime.typeOfTime
  } else {
    const quantityTime = calculateQuantityTime(deliveryDateClient.diff(today, 'minutes'))
    haveDelayInDelivery = false
    differenceOfTime = quantityTime.differenceOfTime
    typeOfTime = quantityTime.typeOfTime
  }

  return { message: differenceOfTime, typeOfTime: typeOfTime, haveDelayInDelivery: haveDelayInDelivery }
}

export const getSlotHours = (slot) => {
  const splitted = slot.split(' ')
  return `${splitted[1]} - ${splitted[4]}`
}

export const calculateDifferenceOfHours = (from, to) => {
  return dayjs(to).diff(dayjs(from), 'minutes')
}

export const hoursFormattedForDynamicParams = () => {
  let hours = []
  for (let hour = 0; hour <= 24; hour++) {
    hours.push(hour)
  }
  return hours
}

export const formatUtcOffset = (timeZone) => {
  if (timeZone) {
    const utcOffset = moment.tz(timeZone).format('Z')
    const sign = utcOffset[0]
    const hours = parseInt(utcOffset.slice(1, 3), 10)
    return `${sign}${hours}`
  }

  return ''
}
